import axios from 'axios'

export const state = {
  all: [],
}

export const getters = {
  getExtraIndex: (state) => (id) =>
    state.all.findIndex((extra) => extra.id === id),
  getExtraById: (state, getters) => (id) =>
    state.all[getters.getExtraIndex(id)],
  getExtraByCart: (state, getters) => (extraCart) =>
    getters.getExtraById(extraCart.id),
}

export const mutations = {
  SET_ALL(state, newExtras) {
    state.all = newExtras
  },
}

export const actions = {
  fetch({ commit }, { property }) {
    return axios.post('/api/v2/get_extras', { property }).then((response) => {
      const { data } = response
      commit('SET_ALL', data)
      return data
    })
  },
}
